// pages/BuildingsPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useHistory  } from "react-router-dom";
import BuildingsGrid from "./BuildingsGrid";

import {API_BASE_URL} from '../../../../config';

import "./map.css";

const BuildingsPage = () => {
  const { propertyId } = useParams();
  const history = useHistory(); 
  const [property, setProperty] = useState(null);

  useEffect(() => {
  const fetchProperty = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}api/property/${propertyId}`);
      if (!res.ok) throw new Error("Failed to fetch property");
      const data = await res.json();

      // Fix: take the first element since API returns [ { property } ]
      setProperty(data);
    } catch (err) {
      console.error(err);
    }
  };

  if (propertyId) {
    fetchProperty();
  }
}, [propertyId]);

const handleGoBack = () => {
    history.push("/property-list", {
      openPropertyId: propertyId,
      openSection: "buildings", // 👈 tell modal which section
    });
  };


  return (
    <div className="p-4">
      <h3 className="text-xl font-semibold mb-4">
        <button onClick={handleGoBack} className="btn ml-4 px-4 py-2 rounded btn-year">  <i class="fa fa-chevron-left mr-2"></i> Go back  </button> 
        {property ? (
          <>
            Property {property.pid ? `[${property.pid}] ` : ""} :
            {property.propertyaddress || ""}, {property.city || ""}, {property.state || ""}
          </>
        ) : (
          "Loading property..."
        )}
        
      
      </h3>

      <BuildingsGrid propertyId={propertyId} />
    </div>
  );
};

export default BuildingsPage;
